import { Container } from './styles'
import { NavHashLink, HashLink } from 'react-router-hash-link'
import { Link, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useI18n } from "../../i18n/I18nProvider"
import logo from "../../assets/logo.png";
import { trackEvent } from '../../utils/analytics'
import { toast } from 'react-toastify'

export function Header() {
  const { t, locale, setLocale } = useI18n();
  const [isActive, setActive] = useState(false)
  const { pathname } = useLocation()

  // the game template provides its own full-screen UI
  const isGameOpen = pathname === '/game'

  const [isFirstVisit, setIsFirstVisit] = useState(false)

  useEffect(() => {
    try {
      const hasVisited = localStorage.getItem('hasVisitedBefore')
      if (!hasVisited) {
        setIsFirstVisit(true)
        localStorage.setItem('hasVisitedBefore', 'true')
      }
    } catch {
      // localStorage unavailable (private browsing, etc.) — skip highlight
    }
  }, [])

  const toggleTheme = () => {
    let html = document.getElementsByTagName('html')[0]
    const isLight = html.classList.toggle('light')
    localStorage.setItem('theme', isLight ? 'light' : 'dark')
    void trackEvent('header_toggle_theme', { mode: isLight ? 'light' : 'dark' })
  }

  const closeMenu = () => {
    setActive(false)
  }

  const handleGenerateCV = async () => {
    try {
      const { generateCV } = await import('../../utils/pdfGenerator');
      generateCV();
      closeMenu(); // Close menu after generating CV
      void trackEvent('header_generate_cv', { source: 'menu' })
    } catch (error) {
      console.error('Error generating CV:', error);
      toast.error('Error generating CV. Please try again.');
    }
  }

  const changeLanguage = () => {
    const newLocale = locale === 'en' ? 'it' : 'en';
    setLocale(newLocale);
    closeMenu();
    void trackEvent('header_change_language', { to: newLocale });
  }

  if (isGameOpen) return null

  return (
    <Container className="header-fixed">
        <HashLink smooth to="/#home" className="logo" onClick={() => void trackEvent('header_logo_click', { to: '/#home' })}>
          <img src={logo} alt="logo" />
        </HashLink>

        <input
          onChange={toggleTheme}
          className="container_toggle"
          type="checkbox"
          id="switch"
          name="mode"
          defaultChecked={typeof document !== 'undefined' && document.documentElement.classList.contains('light')}
        />
        <label htmlFor="switch">{t.header.toggle}</label>



        <nav className={isActive ? 'active' : ''}>
          <NavHashLink smooth to="/#home" onClick={() => { closeMenu(); void trackEvent('header_nav_click', { item: 'home' }); }}>
            {t.header.home}
          </NavHashLink>
          <NavHashLink smooth to="/projects" onClick={() => { closeMenu(); void trackEvent('header_nav_click', { item: 'experience' }); }}>
            {t.header.experience}
          </NavHashLink>
          <Link to="/blog" onClick={() => { closeMenu(); void trackEvent('header_nav_click', { item: 'blog' }); }}>
            {t.header.blog}
          </Link>
          <Link
            to="/game"
            className={isFirstVisit ? 'game-highlight' : ''}
            onClick={() => { setIsFirstVisit(false); closeMenu(); void trackEvent('header_nav_click', { item: 'game' }); }}
          >
            {t.game.navLabel}
          </Link>
          <button className="lang-switch" onClick={changeLanguage}>
            {locale === 'en' ? 'IT' : 'EN'}
          </button>
          <button onClick={() => { handleGenerateCV(); }} className="button button-pdf">
            {t.header.generatePdf}
          </button>
        </nav>

        <button
          type="button"
          aria-expanded={isActive}
          aria-haspopup="true"
          aria-label={isActive ? t.header.menuClose : t.header.menuOpen}
          className={isActive ? 'menu active' : 'menu'}
          onClick={() => {
            setActive(!isActive)
          }}
        ></button>
      
    </Container>
  )
}
